import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const priorities = [
  { value: 'LOW', labe: 'Low', icon: ArrowDownwardIcon },
  { value: 'MEDIUM', labe: 'Medium', icon: ArrowDownwardIcon },
  { value: 'HIGH', labe: 'High', icon: ArrowUpwardIcon },
  { value: 'URGENT', labe: 'Urgent', icon: ArrowUpwardIcon },
];

const FETCH_STATE = {
  UNSENT: 'UNSENT',
  LOADING: 'LOADING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

const MAX_AMOUNT = 21_474_836;

const ADMIN_ROLES = ['admin', 'superadmin'];

/**
 * Regex to check input for it to contain valid unicode from ` ` to `ÿ`
 */
const INPUT_REGEX = /^[ -ÿ]*$/;

export const months = [...Array(12).keys()].map((month) => ({
  value: month + 1,
  label: new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(0, month)),
}));

export const INITIAL_YEAR = 2023;

export const getYears = (initial_year = INITIAL_YEAR) => {
  const years = new Date().getFullYear() - INITIAL_YEAR + 1;

  return [...Array(years).keys()].map((year) => ({
    value: years + initial_year - year - 1,
    label: `${years + initial_year - year - 1}`,
  }));
};

const timeUnits = [
  { value: 'min', label: 'Minutes' },
  { value: 'hr', label: 'Hours' },
  { value: 'd', label: 'Days' },
  { value: 'week', label: 'Weeks' },
  { value: 'month', label: 'Months' },
];

export { priorities, FETCH_STATE, MAX_AMOUNT, INPUT_REGEX, ADMIN_ROLES, timeUnits };
